/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Matriklnr1Inputs */

const en__field_matriklnr1 = /** @type {(inputs: _Field_Matriklnr1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`matriculation number`)
};

const de__field_matriklnr1 = /** @type {(inputs: _Field_Matriklnr1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matrikelnummer`)
};

/**
* | output |
* | --- |
* | "matriculation number" |
*
* @param {_Field_Matriklnr1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_matriklnr1 = /** @type {((inputs?: _Field_Matriklnr1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Matriklnr1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_matriklnr1(inputs)
	return de__field_matriklnr1(inputs)
});
export { _field_matriklnr1 as "_field_matriklNr" }